import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styles from "./DatePendingState.module.scss";

/**
 * Eğitimin başlangıç/bitiş tarihleri henüz atanmamışsa kursiyere sunulan ekran.
 * Talep toplama penceresi açıksa `extra` üzerinden "Talep Et" butonu veya durum
 * chip'i geçirilir — merkezde, kartın altına sabit olarak gösterilir.
 */
export function DatePendingState({ extra }: { extra?: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.iconRing}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h2 className={styles.title}>{t("clientEmptyState.datePending")}</h2>
        <p className={styles.subtitle}>
          Eğitim programı kesinleştiğinde sizinle paylaşılacak. Bu süreçte
          içerik ve programa erişim kapalıdır.
        </p>
        {extra && <div className={styles.action}>{extra}</div>}
      </div>
    </div>
  );
}
